import React, { useState } from 'react';
import style from './TechnicalClearencePayment.module.css';
import { Button, Dropdown } from 'react-bootstrap';
import AuditTrailPopUp from '../audit trail/AuditTrailPopUp.component';
import { mainRoute } from '../../../../services/technicalServices/Technical.service';
import GenericPopupModal from '../../../../components/moduleCommonFormik/GenericModalPopup.component';
import { t } from 'i18next';
import _ from 'lodash';
import ToolTipDetails from '../../../../components/ToolTipFile';

const PaymentSubmissionStatus = ({ data, children, progressBarDetails }: any) => {
    const [show, setShow] = useState<boolean>(false);
    const userType = JSON.parse(localStorage.getItem('type') ?? 'null');
    const handelAudit = () => {
        setShow(true);
    };
    const handelVisible = () => {
        setShow(false);
    };
    console.log('progressBarDetails', data?.bpaData, progressBarDetails);

    return (
        <div className='container font-inter'>
            <div className='row pt-3 col-12 position-relative '>
                <div className='d-flex align-items-center justify-content-between p-0'>
                    <div className='d-flex align-items-center'>
                        <div style={{ fontSize: '18px' }}>{t('REAL_TIME_TRACKER', 'Real Time Tracker')}</div>
                        <ToolTipDetails
                            toolTipDetails={{
                                content: '<div>Days are calculated based on working days</div>',
                                variant: { height: '18px' }
                            }}
                        />
                    </div>
                    <div className='d-flex'>
                        <div style={{ fontSize: '16px', color: '#737C84' }}>
                            {t('PRESCRIBED_TIME', 'Prescribed Time : ')}
                            <span style={{ color: 'black' }}>{progressBarDetails?.prescribedTime ? progressBarDetails?.prescribedTime : 'NA'}</span> &nbsp;&nbsp;
                        </div>
                        <div style={{ fontSize: '16px', color: '#737C84' }}>
                            {t('ACTUAL_TIME', 'Actual Time : ')}
                            <span style={{ color: 'black' }}>{progressBarDetails?.actualTime ? progressBarDetails?.actualTime : 'NA'}</span>
                        </div>
                    </div>

                    {/* <p className='mb-2'>{`Application No`}</p>
                    <h6 className={`${style.initiate}`}>{data?.applicationNo}</h6> */}
                </div>

                {/* <div className={`col-4  ${style.status}`}>
                    <p className='mb-2 text-center'>{'Status'}</p>
                    <h6
                        className={`p-2 text-center  ${
                            data.status === 'Approved' || 'APPROVED'
                                ? `${style.approve}`
                                : data.status === 'Initiated'
                                ? `${style.initiate}`
                                : data.status === 'Draft'
                                ? `${style.initiate}`
                                : `${style.pending}`
                        }`}
                    >
                        {t(data?.status, String(data?.status))}
                    </h6>
                </div>

                <div className={`col-4 flex-end`}>
                    {!_.isEmpty(data?.bpaData?.downloads) && (
                        <Dropdown className='d-inline' style={{ position: 'absolute', right: 0 }}>
                            <Dropdown.Toggle variant='none p-0 border-0' id='dropdown-autoclose-true'>
                                {!data?.pendingWith ? (
                                    <Button
                                        variant='bg-light  outline-success btn  btn-light me-2 font-karla-med py-2  font-14'
                                        disabled={!data?.bpaData?.downloads}
                                        style={{ borderColor: '#45852e', color: '#45852e', width: 'auto', borderRadius: 8, height: 'max-content' }}
                                    >
                                        Download{' '}
                                        <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                                            <path
                                                d='M16.692 7.94205L10.442 14.192C10.384 14.2502 10.3151 14.2963 10.2392 14.3277C10.1633 14.3592 10.082 14.3754 9.99986 14.3754C9.91772 14.3754 9.8364 14.3592 9.76052 14.3277C9.68465 14.2963 9.61572 14.2502 9.55767 14.192L3.30767 7.94205C3.1904 7.82477 3.12451 7.66571 3.12451 7.49986C3.12451 7.33401 3.1904 7.17495 3.30767 7.05767C3.42495 6.9404 3.58401 6.87451 3.74986 6.87451C3.91571 6.87451 4.07477 6.9404 4.19205 7.05767L9.99986 12.8663L15.8077 7.05767C15.8657 6.9996 15.9347 6.95354 16.0105 6.92211C16.0864 6.89069 16.1677 6.87451 16.2499 6.87451C16.332 6.87451 16.4133 6.89069 16.4892 6.92211C16.565 6.95354 16.634 6.9996 16.692 7.05767C16.7501 7.11574 16.7962 7.18468 16.8276 7.26055C16.859 7.33642 16.8752 7.41774 16.8752 7.49986C16.8752 7.58198 16.859 7.6633 16.8276 7.73917C16.7962 7.81504 16.7501 7.88398 16.692 7.94205Z'
                                                fill='#45852E'
                                                stroke='#45852E'
                                                stroke-width='0.5'
                                            />
                                        </svg>
                                    </Button>
                                ) : (
                                    <></>
                                )}
                            </Dropdown.Toggle>
                            {!!data?.bpaData?.downloads && (
                                <Dropdown.Menu>
                                    {Object.keys(data?.bpaData?.downloads).map((key: any) => (
                                        <Dropdown.Item eventKey={key} href={`${data?.bpaData?.downloads[key]}`} target='_blank'>
                                            {key || 'File'}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            )}
                        </Dropdown>
                    )}
                    {userType !== 'ENTERPRISE' && (
                        <Button
                            variant='bg-light outline-success btn btn-light font-karla-med py-2 font-14'
                            style={{ borderColor: '#45852e', color: '#45852e', width: 'auto', borderRadius: 8, height: 'max-content' }}
                            onClick={handelAudit}
                        >
                            <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none'>
                                <path
                                    d='M12.75 7.50003V11.5753L16.1363 13.6069C16.3068 13.7093 16.4297 13.8753 16.4779 14.0684C16.5261 14.2614 16.4956 14.4657 16.3931 14.6363C16.2907 14.8068 16.1247 14.9297 15.9316 14.9779C15.7386 15.0261 15.5343 14.9956 15.3638 14.8932L11.6138 12.6432C11.5028 12.5765 11.4109 12.4822 11.3472 12.3695C11.2834 12.2568 11.25 12.1295 11.25 12V7.50003C11.25 7.30112 11.329 7.11035 11.4697 6.9697C11.6103 6.82905 11.8011 6.75003 12 6.75003C12.1989 6.75003 12.3897 6.82905 12.5303 6.9697C12.671 7.11035 12.75 7.30112 12.75 7.50003ZM12 3.00003C10.8169 2.99708 9.64491 3.22881 8.55193 3.6818C7.45895 4.1348 6.46667 4.80006 5.6325 5.63909C4.95094 6.32909 4.34531 6.99284 3.75 7.68753V6.00003C3.75 5.80112 3.67098 5.61035 3.53033 5.4697C3.38968 5.32905 3.19891 5.25003 3 5.25003C2.80109 5.25003 2.61032 5.32905 2.46967 5.4697C2.32902 5.61035 2.25 5.80112 2.25 6.00003V9.75003C2.25 9.94894 2.32902 10.1397 2.46967 10.2804C2.61032 10.421 2.80109 10.5 3 10.5H6.75C6.94891 10.5 7.13968 10.421 7.28033 10.2804C7.42098 10.1397 7.5 9.94894 7.5 9.75003C7.5 9.55112 7.42098 9.36035 7.28033 9.2197C7.13968 9.07905 6.94891 9.00003 6.75 9.00003H4.59375C5.26406 8.21065 5.93156 7.46722 6.69281 6.69659C7.73518 5.65423 9.0616 4.94216 10.5063 4.64935C11.9511 4.35654 13.4501 4.49598 14.816 5.05023C16.182 5.60449 17.3543 6.54899 18.1866 7.76572C19.0188 8.98245 19.474 10.4175 19.4953 11.8914C19.5166 13.3654 19.1031 14.813 18.3064 16.0532C17.5098 17.2935 16.3652 18.2716 15.0159 18.8651C13.6665 19.4586 12.1722 19.6414 10.7196 19.3905C9.26698 19.1396 7.92052 18.4662 6.84844 17.4544C6.77679 17.3867 6.6925 17.3338 6.60039 17.2986C6.50828 17.2635 6.41015 17.2468 6.3116 17.2496C6.21305 17.2524 6.11602 17.2746 6.02604 17.3149C5.93606 17.3551 5.8549 17.4128 5.78719 17.4844C5.71947 17.5561 5.66654 17.6403 5.6314 17.7325C5.59626 17.8246 5.57961 17.9227 5.5824 18.0212C5.58518 18.1198 5.60735 18.2168 5.64764 18.3068C5.68792 18.3968 5.74554 18.4779 5.81719 18.5457C6.88542 19.5537 8.18414 20.285 9.6 20.6757C11.0159 21.0665 12.5058 21.1047 13.9399 20.7872C15.3739 20.4696 16.7085 19.806 17.827 18.854C18.9456 17.9021 19.8142 16.6909 20.357 15.3261C20.8998 13.9613 21.1003 12.4844 20.9411 11.0243C20.7818 9.56414 20.2677 8.16517 19.4434 6.94947C18.6192 5.73376 17.5099 4.73825 16.2125 4.04982C14.915 3.3614 13.4688 3.00098 12 3.00003Z'
                                    fill='#45852E'
                                    stroke='#45852E'
                                    stroke-width='0.5'
                                />
                            </svg>{' '}
                            Audit Trail
                        </Button>
                    )}
                    <GenericPopupModal
                        display='d-none'
                        title='Audit Trail'
                        subTitle={`Application No. : ${data.applicationNo}`}
                        children={<AuditTrailPopUp appData={data?.data} />}
                        isVisible={show}
                        primaryAction={() => {}}
                        secondaryAction={handelVisible}
                        size='xl'
                    />
                </div> */}
            </div>

            <div className='row pt-5 col-12'>{children}</div>
        </div>
    );
};

export default PaymentSubmissionStatus;
